// extracted by mini-css-extract-plugin
export default {"nav":"LargeScreenHeaderNav-module__nav___hSmtn","navLink":"LargeScreenHeaderNav-module__navLink___mbYYb"};